import { $, addAction, INIT } from '@situation/setdesign.util';
import { setCookie } from '../common/__global';

addAction(INIT, () => {
    const $globalLandingHero = $('.global-landing-hero');
    if (!$globalLandingHero.length) {
        return;
    }

    const $buttons = $globalLandingHero.find('.angle-tear .button');
    $buttons.each((index, value) => {
        const $button = $(value);
        $button.on('click', (e) => {
            e.preventDefault();
            const href = $(this).attr('href');
            if (!href.includes('tour')) {
                setCookie('globalLandingRedirect', href, 30);
            }

            window.location.href = href;
        });
    });
});
